import PropTypes from "prop-types"

const TitleSection = ({ title, text, gemRefs, titleAs: Tag = "h1" }) => {
  return (
    <div className="contained mt-40 text-center" ref={gemRefs}>
      <Tag className="text-35 tablet:px-0 mb-16 px-40 font-bold">{title}</Tag>
      <p className="text-18 tablet:px-64 desktop:px-220 mb-40 px-32">{text}</p>
    </div>
  )
}

TitleSection.propTypes = {
  gemRefs: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  text: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.node,
  ]),
  title: PropTypes.string,
  titleAs: PropTypes.string,
}

export default TitleSection
